/** Lista `ListaStakeManager` (slisBNB) read surface.
 *
 *  slisBNB is a plain ERC-20; the BNB-per-slisBNB rate and the total
 *  pooled BNB live on the StakeManager
 *  (`0x1adb950d8bb3da4be104211d5ab038628e477fe6`):
 *   - `convertSnBnbToBnb(1e18)` → 1e18-scaled BNB-per-slisBNB rate.
 *   - `getTotalPooledBnb()`     → total BNB backing the supply. */
export const ListaStakeManagerReadAbi = [
  {
    name: 'convertSnBnbToBnb',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'amountInSlisBnb' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getTotalPooledBnb',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
